module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Share-bd9b7480354f312bae5ed47d6aefbd7b.svg";